<template>
  <ChartContainer class="d-flex flex-column" :params.sync="params">
    <v-card-title class="flex-grow-0">
      <v-icon class="pl-3 pr-4">mdi-wrench</v-icon>
      Thống kê theo thiết bị
    </v-card-title>
    <v-card-text class="flex-grow-1 full-width full-height">
      <ChartArcContainer
        :backgroundColor="backgroundColor"
        class="pa-6 px-lg-10"
        :data="dataChart"
        hideButton
        :labels="labels"
        :legend="legend"
        :loading="loading"
        :total="totalChart"
        type="percent"
      />
    </v-card-text>
    <v-card-text class="d-flex flex-row full-width justify-space-around">
      <div class="device-item" :title="$n(dataChart[0])">
        <div class="device-icon primary--text">
          <v-icon color="primary">mdi-cellphone</v-icon>
        </div>
        <div class="device-name">Mobile</div>
        <div class="device-percent text-h6">
          {{ getPercent(dataChart[0]) }} %
        </div>
        <GrowthPercentText
          :before="dataBeforeChart[0]"
          :current="dataChart[0]"
        />
      </div>
      <div class="device-item" :title="$n(dataChart[1])">
        <div class="device-icon">
          <v-icon color="primary">mdi-desktop-mac</v-icon>
        </div>
        <div class="device-name">Desktop</div>
        <div class="device-percent text-h6">
          {{ getPercent(dataChart[1]) }} %
        </div>
        <GrowthPercentText
          :before="dataBeforeChart[1]"
          :current="dataChart[1]"
        />
      </div>
      <div class="device-item" :title="$n(dataChart[2])">
        <div class="device-icon">
          <v-icon color="primary">mdi-tablet</v-icon>
        </div>
        <div class="device-name">Tablet</div>
        <div class="device-percent text-h6">
          {{ getPercent(dataChart[2]) }} %
        </div>
        <GrowthPercentText
          :before="dataBeforeChart[2]"
          :current="dataChart[2]"
        />
      </div>
    </v-card-text>
  </ChartContainer>
</template>

<script>
import ChartContainer from '../ChartContainer.vue'
import ChartArcContainer from '@components/chart/ChartArcContainer.vue'
import sdk from '@service/auth-sdk'
import GrowthPercentText from '../GrowthPercentText.vue'
import { debounce, getChartColor, round } from '@utils'
export default {
  components: { ChartArcContainer, ChartContainer, GrowthPercentText },
  props: {},
  data: () => ({
    labels: ['Mobile', 'Desktop', 'Tablet'],
    loading: false,
    backgroundColor: [getChartColor(0), getChartColor(1), getChartColor(2)],
    legend: {
      display: false,
      position: 'top',
      align: 'start',
      labels: {
        usePointStyle: true,
        boxWidth: 6,
      },
    },
    dataChart: [0, 0, 0],
    dataBeforeChart: [0, 0, 0],
    totalChart: 0,
    params: { type: '7days' },
  }),
  computed: {},
  watch: {
    params: {
      handler: debounce(function() {
        this.fetchData()
      }, 100),
      deep: true,
    },
  },
  created() {
    this.fetchData()
  },
  methods: {
    getPercent(data = 0) {
      return round((data / (this.totalChart || 1)) * 100)
    },
    getGrowthPercent(data = 0) {
      return 10
    },
    async fetchData() {
      this.loading = true
      const res = await sdk.request({
        url: '/dashboard/device/total-view',
        params: this.params,
      })
      this.totalChart = 0
      this.dataChart = [0, 0, 0]
      this.dataBeforeChart = [0, 0, 0]
      this.loading = false
      let data = res.data
      for (let item of data.current) {
        if (item.device == 'phone') {
          this.dataChart[0] = item.count
        }
        if (item.device == 'desktop') {
          this.dataChart[1] = item.count
        }
        if (item.device == 'tablet') {
          this.dataChart[2] = item.count
        }
      }
      for (let item of data.before) {
        if (item.device == 'phone') {
          this.dataBeforeChart[0] = item.count
        }
        if (item.device == 'desktop') {
          this.dataBeforeChart[1] = item.count
        }
        if (item.device == 'tablet') {
          this.dataBeforeChart[2] = item.count
        }
      }
      this.totalChart = this.dataChart.reduce((acc, cur) => acc + cur, 0)
    },
  },
}
</script>

<style scoped>
.device-item {
  text-align: center;
}
</style>
